import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import SlideshowB1 from "../Slideshow";
import Refahi from "../../MyFiles/Vector/transportVector.jpg";
import Loan from "../../MyFiles/Vector/loanVector.jpg";
import Survey from "../../MyFiles/Vector/surveyVector.jpg";
import Insurance from "../../MyFiles/Vector/insuranceVector.jpg";
import EServices from "../../MyFiles/Vector/ElectronicServicesVector.jpg";
import Salary from "../../MyFiles/Vector/salaryVector.jpg";
import Clothe from "../../MyFiles/Vector/clotheSurvey.jpg";
import Station from "../../MyFiles/Vector/BustStation.png";
import Signature from "../../MyFiles/Vector/SignatureVector.jpg";
import LoanStep3 from "../../MyFiles/Slide/LoanMehrStep3.png";

//import KosarInsurance from "../../MyFiles/Slide/KosarInsurance1406.jpg";
// import InsuranceAccident from "../../MyFiles/Vector/insuranceAccidentVector.png";
//import GiftCard from "../../MyFiles/Vector/giftVector.jpg";
//import Rahbar from "../../MyFiles/Vector/RahbarVector.png";
//import SurveyBanner from "../../MyFiles/Survey.png";
//import Quran from "../../MyFiles/Vector/quranVector.jpg";
//import CermonyLamerd from "../../MyFiles/Vector/CermonyVectorLamerd.jpg";
//import CermonyPoster from "../../MyFiles/CermonyPoster.jpg";
//import Cermony from "../../MyFiles/Slide/CermonyLamerd.jpg";
//import courseVector from "../../MyFiles/Vector/CourseVector.jpg";
//import SlideCermony from '../../MyFiles/Slide/Slide8.jpg';
//import SlideQuran from "../../MyFiles/Slide/Slide6.jpg";
//import hosseinVector from "../../MyFiles/Vector/HosseinV1Vector.jpg";
//import SlideHossein from "../../MyFiles/Slide/Slide13.jpg";
//import foodSurveyVector from "../../MyFiles/Vector/foodSurvey.png";
//import RefahiTravel from "../../MyFiles/Slide/RefahiTravel.jpg";
//import RahbarTravel from "../../MyFiles/Slide/RahbarTravel.png";
//import RefahiCondition from "../../MyFiles/RefahiCondition.jpg";
//import Course from "../../MyFiles/Slide/Slide9.jpg";
//import CoursePoster from "../../MyFiles/Course.jpg";
//import LoanBanner from "../../MyFiles/Slide/MehrBank.jpg";
//import LoanAnnoncment from "../../MyFiles/1500.jpg";
//import SlideNoor from "../../MyFiles/Slide/Slide11.jpg";
//import SalcoSlide from "../../MyFiles/Slide/SahamSlide.jpg";
//import Saham from "../../MyFiles/Vector/sahamVector.jpg";

class Services extends Component {
  render() {
    const stationUrl = "http://services.salcocomplex.com:8000/s_station/setstation/" + this.props.userJson.md5;
    const signatureUrl = "http://services.salcocomplex.com:8000/person/getSignature/" + this.props.userJson.md5;
    const loanUrl = "http://services.salcocomplex.com:8000/person/loanrequest/" + this.props.userJson.md5;

    return (
      <React.Fragment>
        <div className="body-padding text-center row Services">
          <div className="col-12 px-0 mt-2">
            <React.Fragment>
              <a href={loanUrl} rel="noopener noreferrer" className="wp-link" target="_self">
                <img
                  className="w-100"
                  src={LoanStep3}
                  alt="بانک مهر مرحله 3"
                ></img>
              </a>
            </React.Fragment>
            {/* {this.props.userJson.workplace === 2 ? (
              <React.Fragment>
                <NavLink to="/home/foodSurvey" className="wp-link">
                  <img
                    className="w-100"
                    src={SurveyBanner}
                    alt="نظرسنجی کیفیت غذا"
                  ></img>
                </NavLink>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <NavLink to="/home/refahi" className="wp-link">
                  <img
                    className="w-100"
                    src={RefahiTravel}
                    alt="سفر زیارتی سیاحتی"
                  ></img>
                </NavLink>
              </React.Fragment>
            )} */}
          </div>
          <div className="container-fluid px-4">
            <div className="row">
              {/* {this.props.userJson.isSaham ? (
                <div className="col-4 item">
                  <React.Fragment>
                  <NavLink className="wp-link" to="/home/saham">
                    <img
                      className="img-banner"
                      src={Saham}
                      alt="سهام ترجیحی"
                    ></img>
                    <span>سهام ترجیحی</span>
                  </NavLink>
                  </React.Fragment>
                </div>
              ) : null} */}
              {/* <div className="col-4 item">
                <React.Fragment>
                  <NavLink className="wp-link" to="/home/register">
                    <img
                      className="img-banner"
                      src={hosseinVector}
                      alt="اربعین"
                    ></img>
                    <span>ثبت‌نام اربعین</span>
                  </NavLink>
                </React.Fragment>
              </div> */}

              {/* <div className="col-4 item">
                <React.Fragment>
                  <NavLink className="wp-link" to="/home/lifeAccident">
                    <img
                      className="img-banner"
                      src={InsuranceAccident}
                      alt="عمر و حوادث"
                    ></img>
                    <span>عمر و حوادث</span>
                  </NavLink>
                </React.Fragment>
              </div> */}
              <div className="col-4 item">
                <React.Fragment>
                  <NavLink className="wp-link" to="/home/EServices">
                    <img
                      className="img-banner"
                      src={EServices}
                      alt="خدمات الکترونیک"
                    ></img>
                    <span>خدمات الکترونیک</span>
                  </NavLink>
                </React.Fragment>
              </div>
              {this.props.userJson.isSalary ? (
                <div className="col-4 item">
                  <React.Fragment>
                    <NavLink className="wp-link" to="/home/salary">
                      <img
                        className="img-banner"
                        src={Salary}
                        alt="فیش حقوقی"
                      ></img>
                      <span>فیش حقوقی</span>
                    </NavLink>
                  </React.Fragment>
                </div>
              ) : null}

              {/* {this.props.userJson.contract === 1 ? (
                <div className="col-4 item">
                  <React.Fragment>
                    <NavLink className="wp-link" to="/home/club">
                      <img
                        className="img-banner"
                        src={Salary}
                        alt="باشگاه ورزشی"
                      ></img>
                      <span>باشگاه ورزشی</span>
                    </NavLink>
                  </React.Fragment>
                </div>
              ) : null} */}

              <div className="col-4 item">
                <React.Fragment>
                  <NavLink className="wp-link" to="/home/insurance">
                    <img
                      className="img-banner"
                      src={Insurance}
                      alt="بیمه تکمیلی"
                    ></img>
                    <span>بیمه تکمیلی</span>
                  </NavLink>
                </React.Fragment>
              </div>
              <div className="col-4 item">
                <React.Fragment>
                  <NavLink className="wp-link" to="/home/refahi">
                    <img
                      className="img-banner"
                      src={Refahi}
                      alt="ثبت درخواست سفر زیارتی"
                    ></img>
                    <span>سفرهای سیاحتی زیارتی</span>
                  </NavLink>
                </React.Fragment>
              </div>
              <div className="col-4 item">
                <React.Fragment>
                  {/* <NavLink className="wp-link" to="/home/loan"> */}
                  <a href={loanUrl} rel="noopener noreferrer" className="wp-link" target="_self">
                    <img
                      className="img-banner"
                      src={Loan}
                      alt="ثبت درخواست تسهیلات بانکی"
                    ></img>
                    <span>تسهیلات بانکی</span>
                  </a>
                  {/* </NavLink> */}
                </React.Fragment>
              </div>
              <div className="col-4 item">
                <React.Fragment>
                  <NavLink className="wp-link" to="/home/survey">
                    <img
                      className="img-banner"
                      src={Survey}
                      alt="شرکت در نظرسنجی"
                    ></img>
                    <span>نظر سنجی</span>
                  </NavLink>
                </React.Fragment>
              </div>
              {/* {this.props.userJson.workplace === 2 ? (
                <React.Fragment>
                  <div className="col"></div>
                  <div className="col-4 item">
                    <NavLink className="wp-link" to="/home/foodSurvey">
                      <img
                        className="img-banner"
                        src={foodSurveyVector}
                        alt="ارزیابی روزانه غذا"
                      ></img>
                      <span>ارزیابی روزانه غذا</span>
                    </NavLink>
                  </div>
                  <div className="col"></div>
                </React.Fragment>
              ) : null} */}

              {/* {this.props.userJson.workplace === 2 ? (
                <div className="col-4 item">
                  <React.Fragment>
                    <NavLink className="wp-link" to="/home/course">
                      <img
                        className="img-banner"
                        src={courseVector}
                        alt="کارگاه اکسیژن عاطفی"
                      ></img>
                      <span>کارگاه اکسیژن عاطفی</span>
                    </NavLink>
                  </React.Fragment>
                </div>
              ) : null} */}

              {/* <div className="col-4 item">
                <React.Fragment>
                  <NavLink className="wp-link" to="/home/cermony">
                    <img
                      className="img-banner"
                      src={CermonyLamerd}
                      alt="جشن خانوادگی"
                    ></img>
                    <span>جشن خانوادگی</span>
                  </NavLink>
                </React.Fragment>
              </div> */}
              {/* <div className="col-4 item">
                  <React.Fragment>
                    <NavLink className="wp-link" to="/home/rahbar">
                      <img
                        className="img-banner"
                        src={Rahbar}
                        alt="آقای شهید ایران"
                      ></img>
                      <span>آقای شهید ایران</span>
                    </NavLink>
                  </React.Fragment>
                </div> */}
              {this.props.userJson.isClothe ? (
                <div className="col-4 item">
                  <React.Fragment>
                    <NavLink className="wp-link" to="/home/size">
                      <img
                        className="img-banner"
                        src={Clothe}
                        alt="سایز لباس"
                      ></img>
                      <span>سایزبندی لباس</span>
                    </NavLink>
                  </React.Fragment>
                </div>
              ) : null}
              <div className="col-4 item">
                <React.Fragment>
                  <a href={signatureUrl} rel="noopener noreferrer" className="wp-link" target="_self">
                    <img
                      className="img-banner"
                      src={Signature}
                      alt="امضای دیجیتال"
                    ></img>
                    <span>امضای دیجیتال</span>
                  </a>
                </React.Fragment>
              </div>
              {this.props.userJson.workplace === 2 ? (
                <div className="col-4 item">
                  <React.Fragment>
                    <a href={stationUrl} rel="noopener noreferrer" className="wp-link" target="_self">
                      <img
                        className="img-banner"
                        src={Station}
                        alt="ثبت ایستگاه"
                      ></img>
                      <span>ثبت ایستگاه</span>
                    </a>
                  </React.Fragment>
                </div>
              ) : null}
            </div>
          </div>
          <SlideshowB1></SlideshowB1>
        </div>
      </React.Fragment>
    );
  }
}
export default Services;